// src/layouts/products/components/ProductDetailsView/BasicInfoTab.js
import React from 'react';
import { Grid, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';

// DetailItem can be a local component here or imported if shared elsewhere
function DetailItem({ title, value }) {
  return (
    <ArgonBox mb={1}>
      <ArgonTypography variant="subtitle2" fontWeight="bold" color="textSecondary" sx={{ textTransform: 'capitalize' }}>
        {title.replace(/_/g, ' ')}:
      </ArgonTypography>
      <ArgonTypography variant="body2">{value || 'N/A'}</ArgonTypography>
    </ArgonBox>
  );
}

function BasicInfoTab({ product }) {
  if (!product) return null;

  const additionalFields = product.related_data?.product?.fields;
  const hasAdditionalFields =
    additionalFields && typeof additionalFields === 'object' && Object.keys(additionalFields).length > 0;

  return (
    <ArgonBox p={3}>
      <Grid container spacing={3}>
        {/* --- Basic Information --- */}
        <Grid item xs={12} md={6}>
          <DetailItem title="Product Name" value={product.name || 'N/A'} />
        </Grid>
        <Grid item xs={12} md={6}>
          <DetailItem title="Product Version" value={product.product_version || 'N/A'} />
        </Grid>
        <Grid item xs={12} md={6}>
          <DetailItem title="Created By" value={product.user?.email || 'N/A'} />
        </Grid>
        <Grid item xs={12} md={6}>
          <DetailItem
            title="Created Date"
            value={product.created_date ? new Date(product.created_date).toLocaleString() : 'N/A'}
          />
        </Grid>

        {/* --- Expandable Additional Fields Section --- */}
        {hasAdditionalFields && (
          <Grid item xs={12}>
            <Accordion sx={{ boxShadow: 'none', '&:before': { display: 'none' } }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="additional-fields-content"
                id="additional-fields-header"
                sx={{
                  backgroundColor: (theme) => theme.palette.grey[100],
                  borderRadius: '8px',
                }}
              >
                <ArgonTypography variant="h6" fontWeight="medium">
                  Additional Fields
                </ArgonTypography>
              </AccordionSummary>
              <AccordionDetails>
                <ArgonBox pt={2}>
                  <Grid container spacing={3}>
                    {Object.entries(additionalFields).map(([fieldName, fieldValue]) => (
                      <Grid item xs={12} md={6} key={fieldName}>
                        <DetailItem title={fieldName} value={fieldValue || 'N/A'} />
                      </Grid>
                    ))}
                  </Grid>
                </ArgonBox>
              </AccordionDetails>
            </Accordion>
          </Grid>
        )}
      </Grid>
    </ArgonBox>
  );
}

export default BasicInfoTab;
